<div class="escalate-modal-container">
  <div class="escalate-modal-header">
    <div class="title">{{ 'label.escalate' | translate }}</div>
    <div class="close-button" (click)="close()"><i class="bi bi-x x-icon"></i></div>
  </div>

  <div class="escalate-modal-content">
    <div [formGroup]="form" class="row form-wrapper">
      <div class="col-12 col-md-6">
        <app-checkbox-form-field
          formControlName="customerEscalated"
          [label]="'case.fields.customerEscalated.label' | translate"
          [helpText]="'case.fields.customerEscalated.help'"
          (onChangeCheckboxEvent)="onCheckEscalateCustomer($event)"
        ></app-checkbox-form-field>
      </div>
      <div class="col-12 col-md-6 date-field">
        <app-datepicker-form-field
          formControlName="customerEscalatedDate"
          [label]="'case.fields.customerEscalatedDate.label' | translate"
          [helpText]="'case.fields.customerEscalatedDate.help'"
          [viewMode]="false"
          [placeholder]="''"
        ></app-datepicker-form-field>
      </div>
      <div class="col-12">
        <app-configuration-select-form-field
          formControlName="escalationCategory"
          [label]="'case.fields.escalationCategory.label' | translate"
          [helpText]="'case.fields.escalationCategory.help'"
          [placeholder]="'placeholders.please_select'"
          [clearable]="true"
          [searchable]="true"
          [viewMode]="false"
          [externalSearch]="true"
          [params]="{
            type: dropdownType,
            entry1: form.get('escalationCategory')?.value || ''
          }"
          [entry]="entry1"
          [isRequired]="customerEscalated"
        ></app-configuration-select-form-field>
      </div>
      <div class="col-12">
      <app-select-form-field
        formControlName="customerEscalatedByWhomInternal"
        [label]="'case.fields.customerEscalatedByWhomInternal.label' | translate"
        [helpText]="'case.fields.customerEscalatedByWhomInternal.help'"
        [placeholder]="'placeholders.please_select'"
        [bindValue]="''"
        [bindLabel]="'fullName'"
        [users]="true"
        [searchable]="true"
        [items]="customerInternalUsers"
        (onSelectEvent)="onUserChange($event, 'customerEscalatedByWhomInternal')"
        [externalSearch]="true"
        (onSearchEvent)="searchUsers('search', $event.term, 'customerInternalUsers', $event.page, $event.take)"
        (onScrollEvent)="searchUsers('scroll', $event.term, 'customerInternalUsers', $event.page, $event.take)"
      ></app-select-form-field>
      </div>
      <div class="col-12">
      <app-input-form-field
          formControlName="customerEscalatedByWhomExternal"
          [label]="'case.fields.customerEscalatedByWhomExternal.label' | translate"
          [helpText]="'case.fields.customerEscalatedByWhomExternal.help'"
          [translatable]="false"
          [viewMode]="false"
      ></app-input-form-field>
      </div>
      <div class="col-12">
      <app-select-form-field
        formControlName="escalationTeam"
        [label]="'case.fields.escalationTeam.label' | translate"
        [helpText]="'case.fields.escalationTeam.help'"
        [placeholder]="'placeholders.please_select'"
        [multipleSelect]="true"
        [bindValue]="''"
        [bindLabel]="'fullName'"
        [users]="true"
        [searchable]="true"
        [items]="escalationTeamUsers"
        [isRequired]="customerEscalated"
        (onSelectEvent)="onUserChange($event, 'escalationTeam')"
        [externalSearch]="true"
        (onSearchEvent)="searchUsers('search', $event.term, 'escalationTeamUsers', $event.page, $event.take)"
        (onScrollEvent)="searchUsers('scroll', $event.term, 'escalationTeamUsers', $event.page, $event.take)"
      ></app-select-form-field>
      </div>
      <div class="col-12">
        <app-textarea-form-field
        formControlName="reasonForEscalation"
        [label]="'case.fields.reasonForEscalation.label' | translate"
        [helpText]="'case.fields.reasonForEscalation.help'"
        [placeholder]="''"
        [isRequired]="customerEscalated"
      ></app-textarea-form-field>
      </div>
    </div>
  </div>

  <div class="escalate-modal-footer">
    <div class="submit-actions">
      <button class="btn secondary-button" (click)="close()">{{ 'label.cancel' | translate }}</button>
      <button [disabled]="!form.valid" class="btn primary-button" (click)="confirm()">{{ 'label.escalate' | translate }}</button>
    </div>
  </div>
</div>
